<template>
  <div class="fotoportada-container">
    <!-- Oscurecimiento superior -->
    <div class="dark-overlay"></div>

    <div class="overlay-content">
      <!-- 1. NOMBRE -->
      <div class="centered-text anim-entrada">
        <span class="nombre-principal">Scarleth</span>
      </div>

      <!-- 2. MIS XV -->
      <div class="mis-xv-wrapper anim-entrada delay-1">
        <div class="mis-xv-top">
          MY XV
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoverComponent'
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@500&display=swap');

.fotoportada-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  margin-top: -60px;
  background-image: 
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0)
    ), 
    url('@/assets/WhatsApp Image 2026-08-16 at 2.23.06 PM_11zon.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  z-index: 1;
  contain: strict;
}

/* Oscurecimiento superior inmediato */
.dark-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50%;
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.7) 0%,
    transparent 100%
  );
  z-index: 2;
  animation: fadeInSutil 0.4s ease-out forwards;
}

/* Contenedor Flex */
.overlay-content {
  position: relative;
  z-index: 3;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  gap: 16px;
  margin-top: -220px;
}

/* ANIMACIONES NATIVAS EN GPU */
.anim-entrada {
  animation: entradaAcelerada 0.5s ease-out forwards;
  will-change: transform, opacity;
  backface-visibility: hidden;
}

.delay-1 {
  animation-delay: 0.15s; /* Escalonado fluido sin lags */
}

@keyframes entradaAcelerada {
  0% {
    opacity: 0;
    transform: translate3d(0, 15px, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInSutil {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

/* TEXTOS */
.centered-text {
  text-align: center;
  font-family: 'CynthiaJuneJF', serif;
  font-size: 88px;
  line-height: 1.1;
  color: #ffffff;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
}

.nombre-principal {
  display: block;
  
}

.mis-xv-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mis-xv-top {
  font-family: 'Cinzel', serif;
  font-size: 20px;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.6);
}
</style>